import dynamic from 'next/dynamic';

const LastChanceDepositDynamic = dynamic(
  async () => import('./index').then((m) => m.LastChanceDeposit),
  {
    ssr: false,
    loading: () => null,
  }
);

export { LastChanceDepositDynamic };
